import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { jwtDecode } from "jwt-decode";


import { useOrderFormClearData } from './use-order-form-clear-data.hook'
import { useOrderFormStore } from '../stores/order-form.store'
import { useAuthStore } from '@/modules/shared/stores/auth.store'

type JWTDecoded = {
	idUsuario: string;
	usuario: string;
	versao: string;
	sessao: string;
	vendedor: string;
}

export const useSaveOrderWhenHaveInStorage = () => {
  const navigate = useNavigate()

  const { jsonOrderForm, operationType } = useOrderFormStore()

  const { clearAllDataOfOrder } = useOrderFormClearData()

	const {token} = useAuthStore()

  const checkIfOrderInStorage = async () => {

		const decoded = jwtDecode<JWTDecoded>(token);

		if(decoded.vendedor !== jsonOrderForm?.fkVendedor) {
			clearAllDataOfOrder()
			navigate('/pedidos')
			return
		}

    const cartIsEmpty = jsonOrderForm?.itemsCalculo?.length <= 0

    if (!jsonOrderForm || cartIsEmpty || operationType === 'view') {
      clearAllDataOfOrder()
      navigate('/pedidos')
    } else {
      setTimeout(() => {
        toast.success('Pedido restaurado com sucesso!')

        if (operationType === 'edit') {
          navigate(`/pedido/edit/${jsonOrderForm.idPedido}`)
        } else if (operationType === 'add') {
          navigate('/pedido/add')
        }
      }, 1000)
    }
  }
  return {
    checkIfOrderInStorage,
  }
}
